export const TAX_INFO = 'lender_taxinfo'
export const DOCUMENT_INFO = 'lender_document'
export const ADDRESS_INFO = 'lender_address'
export const PERSONAL_INFO = 'lender_personalinfo'
export const BANK_INFO = 'lender_bankinfo'
export const BUSSINESS_INFO = 'lender_bussinesinfo'